import React from "react";
import { classes } from "lib/actions/util";
import { motion } from "motion/react";

interface ComponentProps {
  progressColorClass?: string;
  bgColorClass?: string;
}

// adapted from: https://codepen.io/shalimano/pen/wBmNGJ
const ProgressBarIndeterminate = ({
  progressColorClass = "bg-blue-500",
  bgColorClass = "bg-blue-100",
}: ComponentProps) => {
  const expandingVariants = {
    from: { left: "-50%", width: "10%" },
    to: { left: "120%", width: "50%" },
  };

  const shrinkingVariants = {
    from: { left: "-120%", width: "60%" },
    to: { left: "110%", width: "10%" },
  };

  return (
    <div className="absolute h-full w-full overflow-x-hidden">
      <div
        className={classes("absolute h-full", bgColorClass)}
        style={{ width: "150%" }}
      >
        {/* expanding bar */}
        <motion.div
          initial="from"
          animate="to"
          transition={{
            repeat: Infinity,
            duration: 3,
          }}
          variants={expandingVariants}
          className={classes("absolute h-full w-full", progressColorClass)}
        />

        {/* shrinking bar */}
        <motion.div
          initial="from"
          animate="to"
          transition={{
            repeat: Infinity,
            duration: 3,
            delay: 1,
          }}
          variants={shrinkingVariants}
          className={classes("absolute h-full w-full", progressColorClass)}
        />
      </div>
    </div>
  );
};

export default ProgressBarIndeterminate;
